'use client';

import { Button } from '@pickleballinc/react-ui';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';
import clsx from 'clsx';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { DetailNavigation } from '@/modules/league/new-components/types';
import { useLoader } from '@/modules/league/PickleballLoaderContext';

interface NavLinkProps {
  text: string;
  pageType: string | undefined;
  currentType: string;
  params: { slug: string; sessionId: string };
}

const NavLink = ({ text, pageType, currentType, params }: NavLinkProps) => {
  const searchParams = useSearchParams();
  const router = useRouter();

  const isActive = pageType === currentType;
  const { slug, sessionId } = params;

  const { setLoading } = useLoader();

  useEffect(() => {
    setLoading(false);
  }, [pageType]);

  return (
    <CustomLink
      href={`/leagues/${slug}/session/${sessionId}?tab=${currentType}`}
      className='flex w-full'
      passHref
      onClick={(e) => {
        if (currentType !== pageType) {
          e.preventDefault();

          setLoading(true);
          const newSearchParams = new URLSearchParams(searchParams?.toString());
          newSearchParams.set('tab', currentType);

          router.replace(`?${newSearchParams.toString()}`, {
            scroll: currentType === 'sponsors' ? true : false,
          });
        }
      }}
    >
      <Button
        variant={isActive ? 'primary' : 'secondary'}
        className={clsx(
          'flex w-full justify-center rounded-md font-semibold text-gray-700',
          currentType !== 'standings' && 'ml-4',
          isActive
            ? '!bg-leagues-500 !text-white hover:!bg-leagues-300'
            : '!bg-white !text-gray-700 hover:!bg-gray-100'
        )}
      >
        {text}
      </Button>
    </CustomLink>
  );
};

const DetailsNav = ({ showSponsors, params }: DetailNavigation) => {
  const searchParams = useSearchParams();
  const pageType = searchParams?.get('tab') || 'standings';

  return (
    <div className='flex w-full justify-between p-1'>
      <NavLink text='Standings' pageType={pageType} currentType='standings' params={params} />
      <NavLink text='Schedule' pageType={pageType} currentType='schedule' params={params} />
      <NavLink text='Info' pageType={pageType} currentType='info' params={params} />
      {showSponsors ? (
        <NavLink text='Sponsors' pageType={pageType} currentType='sponsors' params={params} />
      ) : null}
    </div>
  );
};

export default DetailsNav;
